var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.59714 1.20857C7.81963 0.98608 7.81963 0.625349 7.59714 0.402857C7.37465 0.180365 7.01392 0.180365 6.79143 0.402857L4 3.19429L1.20857 0.402858C0.98608 0.180366 0.625349 0.180365 0.402857 0.402857C0.180365 0.625349 0.180365 0.98608 0.402857 1.20857L3.19429 4L0.402858 6.79143C0.180366 7.01392 0.180365 7.37465 0.402857 7.59714C0.625349 7.81963 0.98608 7.81963 1.20857 7.59714L4 4.80571L6.79143 7.59714C7.01392 7.81963 7.37465 7.81963 7.59714 7.59714C7.81963 7.37465 7.81963 7.01392 7.59714 6.79143L4.80571 4L7.59714 1.20857Z",
    fill: "#52509A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.bae7771152845a5edd4ecf45eaf4f56f.svg";
export { ForwardRef as ReactComponent };